import './SigninButton.css';
import googleLogo from "../../assets/google-logo.svg";
import {logSignUpIntent, signInWithGooglePopUp} from "../../lib/helpers/signInHelper.ts";
import { captureMessage } from "../../lib/sentry";


function SignInWithGoogleButton() {

    const handleGoogleSignIn = async () => {
        logSignUpIntent("google.com");

        try {
            await signInWithGooglePopUp();
        } catch (error) {
            captureMessage(`SignInWithGoogleButton: ${error}`);
        }
    }

    return (
        <button
            className="sign-in-button body-md semibold"
            onClick={handleGoogleSignIn}
            aria-label="Sign up with Google">

            <img className="google-logo" src={googleLogo} alt="google logo"/>
            Sign up with Google
        </button>
    )
}

export default SignInWithGoogleButton
